export const UrlBaseServer = "https://vignitus.fr";
//export const UrlBaseServer = "https://vignitus.consonni.fr/";
